import React from 'react';

import './index.scss';

type Props = {
  title: string;
  content: string;
  url: string;
  category?: string;
  path?: string;
}

const ArticlesCard = (props: Props) => {
  const { title, content, url, category, path } = props;
  return (
    <a className="odc-articles-card"
      href={url}
      target="_blank"
      rel="noreferrer"
    >
      <div className="odc-articles-card-title">{title}</div>
      <div className="odc-articles-card-desc">{content}</div>
      <div className="odc-articles-card-meta">
        {category && <span className="odc-articles-card-category">{category}</span>}
        {path && <span className="odc-articles-card-path">{path}</span>}
      </div>
    </a>
  );
};

export default ArticlesCard;